import {remCalc} from '../../_utils'

export default {
    baseStyle: ({addressLength}: {addressLength: number}) => ({
        stack: {
            position: 'absolute',
            top: remCalc(-50),
            right: remCalc(0),
            gap: '0',
        },
        actionCardStack: {
            gap: remCalc(0),
            height: '100%',
            justifyContent: 'space-between',
        },
        childrenFlex: {
            textStyle: 'body-medium',
            flexDirection: 'column',
            gap: remCalc(0),
        },
        guestActionCardContainer: {
            padding: `${remCalc(16)} ${remCalc(16)} ${remCalc(16)} ${remCalc(16)}`,
            flexDirection: 'column',
            gap: remCalc(8),
            position: 'relative',
            cursor: 'pointer',
            border: 'small',
            borderStyle: 'solid',
            borderColor: '#DEDCDA',
            borderRadius: 'large',
            bg: 'background.neutral.hover',
            minWidth: {lg: addressLength > 1 ? 'unset' : remCalc(451)},
            w: '100%',
            outline: 'none',
        },
        pickupAddressCardContainer: {
            p: remCalc(16),
            flexDirection: 'row',
            gap: remCalc(8),
            position: 'relative',
            cursor: 'pointer',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            minWidth: {lg: addressLength > 1 ? 'unset' : remCalc(451)},
        },
        cardContainer: {
            padding: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
            flexDirection: 'column',
            gap: remCalc(20),
            position: 'relative',
            cursor: 'pointer',
            border: 'small',
            borderStyle: 'solid',
            borderColor: '#DEDCDA',
            minWidth: {lg: addressLength > 1 ? 'unset' : remCalc(451)},
            borderRadius: 'large',
            bg: 'background.light-dark',

            _hover: {
                bg: 'background.neutral.hover',
            },
            outline: 'none',
        },
        cardAccesibility: {
            _focus: {
                outline: 'none !important',
                boxShadow: 'none !important',
            },
            _focusVisible: {
                outline: '2px solid !important',
                outlineColor: 'blue.500 !important',
                outlineOffset: '2px !important',
                boxShadow: 'none !important',
            },
        },
        radioCardFlexChild: {
            alignItems: 'center',
            gap: remCalc(9),
        },
        radioCardText: {
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        customRadioInputContainer: {
            h: remCalc(24),
            w: remCalc(24),
            border: 'small',
            borderStyle: 'solid',
            borderRadius: '50%',
        },
        customRadioInputContainerBull: {
            h: remCalc(12),
            w: remCalc(12),
            m: remCalc(5),
            borderStyle: 'solid',
            borderRadius: '50%',
            backgroundColor: 'background.dark',
        },
        addressName: {
            textStyle: 'body-medium',
            fontWeight: 'medium',
        },
        privacyText: {
            color: 'text.secondary',
            textStyle: 'body-small',
        },
        boxedCardContainer: {
            marginBottom: remCalc(12),
        },
    }),
    variants: {
        'address-card': {
            closeButton: {
                position: 'absolute',
                top: remCalc(24),
                right: remCalc(20),
                display: 'flex',
            },
            actionCardBox: {
                maxW: {base: '100%', lg: remCalc(451)},
                padding: {base: 'small.base', md: 'small.md', lg: 'small.lg', xl: 'small.xl'},
                border: 'small',
                borderStyle: 'solid',
                borderColor: '#DEDCDA',
                borderRadius: 'large',
                bg: 'background.light-dark',
            },
            actionCardStack: {
                gap: remCalc(40),
                height: '100%',
                justifyContent: 'space-between',
            },
            checkboxDefault: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: remCalc(8),
                label: {
                    fontSize: 'sm',
                    fontWeight: 'bold',
                },
            },
        },
        boxed: {
            stack: {
                position: 'absolute',
                top: remCalc(8),
                right: remCalc(15),
                gap: '0',
            },
            editPosition: {
                position: 'relative',
                top: 'auto',
                right: 'auto',
            },
            childrenFlex: {
                textStyle: 'body-medium',
                flexDirection: 'row',
                gap: remCalc(8),
                alignItems: 'flex-start',
                w: '100%',
            },
            actionCardStack: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                width: '100%',
            },
        },
        pickupPoint: {},
        checkout: {
            actionCardStack: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                width: '100%',
            },
            actionCardBox: {
                width: '100%',
            },

            childrenFlex: {
                flex: 1,
                marginRight: remCalc(16),
                width: '100%',
            },

            editPosition: {
                position: 'relative',
                top: 'auto',
                right: 'auto',
                display: 'inline-flex',
                alignItems: 'center',
            },
            cardContainer: {
                padding: `${remCalc(16)} ${remCalc(16)} ${remCalc(16)} ${remCalc(16)}`,
                flexDirection: 'row',
                alignItems: 'flex-start',
                gap: remCalc(8),
            },
            radioCardText: {
                display: 'none',
            },
        },
    },
    parts: [
        'actionCardBox',
        'actionCardStack',
        'cardContainer',
        'stack',
        'childrenFlex',
        'radioCardFlexChild',
        'radioCardText',
        'customRadioInputContainer',
        'customRadioInputContainerBull',
        'closeButton',
        'checkboxDefault',
        'editPosition',
    ],
}
